const componentStyles = {
    footer: {
        borderColor: "#8c3db9",
        padding: "50px 0",
        borderTop: "2px solid #435DB5",
        background: "radial-gradient(ellipse at bottom, #292D61 30%, #171941 80%)",
        marginTop: '3%'
    },
};
export default componentStyles;
